import React from 'react';

import lockWarningTokens from '@amzn/meridian-tokens/base/icon/lock';
import Alert from '@amzn/meridian/alert';
import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';

import { isArray, isNil } from 'lodash';

type AllowedLink = 'jira.music.amazon.dev' | 'quip-amazon.com' | 'w.amazon.com';

type IReactElementWithDisable = React.ReactElement<{ disabled: boolean }>;

type IAndonCord = {
    /**
     * The reason the element is disabled. This should be a link
     * to a jira ticket, quip doc, wiki page, etc.
     */
    reason: `https://${AllowedLink}/${string}`;

    /**
     * Indicates that the element should be disabled. True by default.
     *
     * If false, the element is rendered normally.
     */
    pulled?: boolean;

    /**
     * The elements to disable. Each child will be disabled and have
     * a "lock" icon added next to it.
     */
    children: IReactElementWithDisable;
};

const TOOLTIP_MESSAGE = 'This field has been disabled. Click the lock for more info.';

export function AndonCord(props: IAndonCord) {
    return !isNil(props.pulled) && !props.pulled ? (
        <> {props.children} </>
    ) : (
        <>
            <Row alignmentHorizontal={'start'} width={'100%'} widths={['fill', 'fit']}>
                {React.cloneElement(props.children, { disabled: true })}
                <Tooltip position={'end'} title={TOOLTIP_MESSAGE}>
                    <Button
                        type={'secondary'}
                        href={props.reason}
                        target={'_blank'}
                        data-testid={'explanation'}
                        rel={'noopener noreferrer'}
                    >
                        <Icon tokens={lockWarningTokens} />
                    </Button>
                </Tooltip>
            </Row>
        </>
    );
}
